

// 自裂变分享来源枚举值
export enum ShareSourceEnum {
  // Website
  Website = 1,
  // Telegram
  Telegram = 2,
  // WhatsApp
  WhatsApp = 3,
  // Facebook
  Facebook = 4,
  // QR
  QR = 5,
} 